/**
 * LegalGuaranteeNotice - Legal guarantee notice trigger + popup
 *
 * Renders a single "Garanția legală" button in the footer. Opening it shows
 * the existing notice image full-size in a Dialog (uncontrolled, Radix
 * handles open state, Escape/close/focus-return natively).
 *
 * Renders nothing when no image URL is provided (no broken control).
 */

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../../Theme'

interface LegalGuaranteeNoticeProps {
  imageUrl?: string
}

export function LegalGuaranteeNotice({ imageUrl }: LegalGuaranteeNoticeProps) {
  if (!imageUrl) {
    return null
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          Garanția legală
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[95vw] sm:max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-main-font text-lg">Garanția legală</DialogTitle>
          <DialogDescription className="font-main-font text-base">
            Notificarea privind garanția legală, ca imagine.
          </DialogDescription>
        </DialogHeader>
        <img
          src={imageUrl}
          alt="Notificare privind garantia legala de conformitate a produselor"
          width={1100}
          height={1298}
          className="w-full h-auto"
        />
      </DialogContent>
    </Dialog>
  )
}
